<template>
  <div class="kp-flat-card small-shadow pl-40 pr-40 pb-40 pt-30">
    <h4 class="mb-25">Analytics</h4>
    <div class="graph-filters mb-4">
      <div class="row row-eq-height align-items-center">
        <div class="col">
          <div class="btn-group btn-group-toggle chart-toggles range-toggles" data-toggle="buttons">
            <button class="btn" :class="{active: timeItem === item}" v-for="(item, index) in time" :key="index" @click="randomize(item)">{{item}}</button>
          </div>
          <div class="mb-10 d-sm-none"></div>
          <div class="btn-group btn-group-toggle chart-toggles" data-toggle="buttons">
            <button class="btn" :class="{active: frequencyItem === item}" v-for="(item, index) in frequency" :key="index" @click="frequencyItem = item">{{item}}</button>
          </div>
        </div>
        <div class="col-auto">
          <div class="chart-summary">
            <div class="mt-20 d-xl-none"></div>
            <ul>
              <li>
                <span>Gross volume</span>
                <h4>€1,234.00</h4>
              </li>
              <li>
                <span>New customers</span>
                <h4>25</h4>
              </li>
              <li>
                <span>Successful payments</span>
                <h4>154</h4>
              </li>
              <li>
                <span>New volume sales</span>
                <h4>€1,000.00</h4>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
    <div class="main-analytics">
      <apexchart type=bar height=350 :options="chartOptions" :series="series" />
    </div>
  </div>
</template>

<script>
export default {
  name: 'main-analytics',
  data() {
    return {
      time: ['1w', '4w', '1y', 'Mtd', 'Qtd', 'Ytd', 'All'],
      timeItem: '1w',
      frequency: ['Hourly', 'Daily'],
      frequencyItem: 'Hourly',
      series: [{
        name: 'Transfer',
        data: [44, 55, 41, 67, 22, 43, 44, 55, 41, 67, 22, 43, 44, 55, 41, 67, 22, 43, 22, 43]
      }, {
        name: 'Commision',
        data: [13, 23, 20, 8, 13, 27, 13, 23, 20, 8, 13, 27, 13, 23, 20, 8, 13, 27, 13, 27]
      }, {
        name: 'Fees',
        data: [11, 17, 15, 15, 21, 14, 11, 17, 15, 15, 21, 14, 11, 17, 15, 15, 21, 14, 21, 14]
      }],
      chartOptions: {
        colors: ['#545454', '#ef781d', '#f2f2f2'],
        chart: {
          stacked: true,
          toolbar: {
            show: false
          }
        },
        responsive: [{
          breakpoint: 480,
          options: {
            legend: {
              show: false
            },
          }
        }],
        grid: {
          borderColor: '#cfcfcc',
          strokeDashArray: 5
        },
        plotOptions: {
          bar: {
            horizontal: false,
            endingShape: 'rounded',
            columnWidth: '30%',
          },
        },
        dataLabels: {
          style: {
            fontSize: '12px',
            fontFamily: '"Source Sans Pro", Helvetica, Arial, sans-serif',
            colors: ['#fff', '#fff', '#222']
          },
        },
        xaxis: {
          type: 'datetime',
          categories: ['09/29/2019 GMT', '09/30/2019 GMT', '10/01/2019 GMT', '10/02/2019 GMT', '10/03/2019 GMT', '10/04/2019 GMT',
            '10/05/2019 GMT', '10/06/2019 GMT', '10/07/2019 GMT', '10/08/2019 GMT', '10/09/2019 GMT', '10/10/2019 GMT', '10/11/2019 GMT',
            '10/12/2019 GMT', '10/13/2019 GMT', '10/14/2019 GMT', '10/15/2019 GMT', '10/16/2019 GMT', '10/17/2019 GMT', '10/18/2019 GMT'
          ],
          labels: {
            style: {
              fontFamily: '"Source Sans Pro", Helvetica, Arial, sans-serif',
            }
          },
          axisBorder: {
            show: false
          }
        },
        yaxis: {
          show: false,
          min: 0,
          max: 100,
          tickAmount: 5,
          axisBorder: {
            show: false
          }
        },
        legend: {
          show: false
        },
        fill: {
          opacity: 1
        }
      }
    }
  },
  methods: {
    rand(min, max) {
      return Math.round(Math.floor(Math.random() * (max - min + 1)) + min)
    },
    randomize(item) {
      const self = this
      this.timeItem = item
      const newSeries = []
      this.series.forEach((series, index) => {
        const newSeriesData = series.data.map(el => Math.floor(self.rand(0, 60) / (index + 1)))
        newSeries.push({
          name: series.name,
          data: newSeriesData
        })
      })
      this.series = newSeries
    }
  }
}
</script>
